import { render, staticRenderFns } from "./nextOfKin.vue?vue&type=template&id=67186584"
import script from "./nextOfKin.vue?vue&type=script&lang=js"
export * from "./nextOfKin.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports